import { render } from "./Donate.vue?vue&type=template&id=5b35da80&scoped=true"
import script from "./Donate.vue?vue&type=script&lang=js"
export * from "./Donate.vue?vue&type=script&lang=js"

import "./Donate.vue?vue&type=style&index=0&id=5b35da80&scoped=true&lang=css"

import exportComponent from "/Users/danielseguin/Documents/Websites/ootp-calculator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b35da80"]])

export default __exports__